import { IconButton } from '@mui/material';
import { FunctionComponent } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { DialogButton } from 'src/components/elements/DialogButton';
import { editNote } from '../api/editNote';
import { getNote } from '../api/getNote';
import { Note } from '../types/note';
import { NoteForm } from './NoteForm';
import EditIcon from '@mui/icons-material/Edit';
import { Loading } from 'src/components/elements/Loading';

export const EditNoteButton: FunctionComponent<{ id: string }> = ({ id }) => {
  return (
    <DialogButton
      label="Edit"
      button={
        <IconButton>
          <EditIcon />
        </IconButton>
      }
    >
      {(closeDialog) => <EditNoteForm id={id} closeDialog={closeDialog} />}
    </DialogButton>
  );
};

const EditNoteForm: FunctionComponent<{
  id: string;
  closeDialog: () => void;
}> = ({ id, closeDialog }) => {
  const queryClient = useQueryClient();
  const editMutation = useMutation(editNote, {
    onSuccess: () => queryClient.invalidateQueries('notes'),
  });

  const { isLoading, data } = useQuery(['note', id], () => getNote(id));

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <NoteForm
          initialData={data || new Note()}
          title="Edit"
          onSaveClick={(note: Note) =>
            editMutation.mutate(note, {
              onSuccess: closeDialog,
            })
          }
          closeDialog={closeDialog}
        />
      )}
    </>
  );
};
